export const pageWidth = 795; // in px
export const pageHeight = 1032; // in px

export const sharedColor = '#38bdf8';
